
import React, { useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from "react-i18next";
import Tiff from "tiff.js";
const MyDropzone = ({ onChange, onSelected, onSelectedFileIdx, ...rest }) => {
    const { t } = useTranslation();

    const [files, setFiles] = React.useState(rest.files || []);

    const [selectedFile, setSelectedFile] = React.useState();


    useEffect(() => {
        if (rest.files) {
            setFiles(rest.files);
            if (!selectedFile && rest.files) {
                setSelectedFile(rest.files[0]);
            }
        }
    }, [rest.files]);

    const onDrop = useCallback(async acceptedFiles => {

        const newFiles = await Promise.all(acceptedFiles.map(assignBlob));

        setFiles(prev => {
            const allFiles = [...prev, ...newFiles];
            onChange(allFiles);
            const newSelected = newFiles[0];
            setSelectedFile(newSelected);
            onSelected(newSelected);
            onSelectedFileIdx(prev.length);
            return allFiles;

        });
    }, []);

    const onPreviewClick = idx => {
        setSelectedFile(files[idx]);
        onSelected(files[idx]);
        onSelectedFileIdx(idx);
    };

    const { acceptedFiles, getRootProps, getInputProps, isDragActive,
        isDragAccept,
        isDragReject, } = useDropzone({ onDrop, accept: 'image/*', });


    acceptedFiles.map(file => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
        </li>
    ));


    const onRemoveItem = idx => {
        var newFiles = [...files];
        const removedFile = newFiles.splice(idx, 1);
        setFiles(newFiles);
        onChange(newFiles);

        if (true || removedFile.blob === (selectedFile && selectedFile.blob)) {

            const newSelected = newFiles ? newFiles[0] : null;

            setSelectedFile(newSelected);
            onSelected(newSelected);
        }

    };

    return (
        <div
            {...getRootProps({
                className: `dropzone
                ${isDragAccept && 'dropzone-accept'}
                ${isDragReject && 'dropzone-reject'}`,
            })}
        >
            <input {...getInputProps()} />

            {files.map((file, idx) => {
                return <div className={"dz-preview" + (file === selectedFile ? " selected" : '')}
                    key={idx}
                    id={file.id}>
                    <div className="dz-image"
                        style={{ backgroundImage: `url(${file.blob})` }}
                        onClick={e => { e.stopPropagation(); onPreviewClick(idx); }}>
                    </div>
                    <button
                        className="dz-remove btn btn-sm btn-link"
                        onClick={(e) => { e.stopPropagation(); e.preventDefault(); onRemoveItem(idx); }}>
                        <span className="oi oi-x"></span>
                    </button>
                </div>;
            })}

            <div className={"dz-message " + (files && files.length ? "dz-message-bottom" : "")}>
                {
                    isDragActive ? <>Drop the files here ...</>
                        : <><span className="oi oi-plus"></span> {t('Add images')}</>
                }
            </div>
        </div >
    );
};


const assignBlob = async file => {

    const blob = await createBlob(file);
    return Object.assign(file, {
        blob
    });
};

const createBlob = async file => {
    if (file.type == "image/tiff") {
        return await createTiffBlob(file);
    }
    return URL.createObjectURL(file);
};

const createTiffBlob = async file => {
    const myPromise = new Promise((resolve, reject) => {



        var reader = new FileReader();
        reader.onload = (function (theFile) {
            return function (e) {
                var buffer = e.target.result;
                var tiff = new Tiff({ buffer: buffer });
                const blob = tiff.toDataURL();
                resolve(tiff.toDataURL());
            };
        })(file);
        reader.readAsArrayBuffer(file);

    });
    return myPromise;
};

export default MyDropzone;